import React from 'react';

import sAction from 'sAction';

function RequestAccessSent() {
    return (
        <div className="loginBoxContainer requestAccessSuccess">
            <div className="requestAccessSuccessGrid">
                <div className="requestAccessSuccessImg">
                    <img src='img/aon_success_icon.svg' alt='success' />
                </div>
                <div className="requestAccessSuccessContentFormContainer">
                    <h2>{sAction.translate('LBL_PORTAL_ACCESS_REQUEST_SENT')}</h2>
                    <p>{sAction.translate('LBL_PORTAL_ACCESS_REQUEST_SENT_DESC')}</p>
                </div>
            </div>
        </div>
    );
}

export default RequestAccessSent;
